export default __webpack_public_path__ + "static/media/1c348688be0ae0e3.da4625e5b97b775232bc603607b938fe.svg";